import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { email, required, SimpleForm, TextInput } from 'react-admin';
import { makeStyles } from '@material-ui/core';
import { EulaTermsInput } from './EulaTermsInput';
import { UserCreateToolbar } from './UserCreateToolbar';
import { useUsercreate } from './UserCreate';
import { RoleSelectInput } from './RoleSelectInput';
import { setIsNewAccCreated } from '../../lib/authentication/authProvider';
import { nameValidation } from '../authentication/SignUp';
import { CustomDialog } from '../common';
import { useUserContext } from '../userContexts';

export const UserCreateForm = props => {
    const classes = useStyles(props);
    const { toolbarProps } = props;
    const [usercreate] = useUsercreate();
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const [selectedRole, setSelectedRole] = useState(null);
    const [customError, setCustomError] = React.useState('');
    const [userContext] = useUserContext();

    const onSubmit = form => {
        delete form.roleName;
        form.access = [
            {
                roleUuid: selectedRole,
                orgUuid: userContext?.userDetails?.organizationUuid,
            },
        ];
        usercreate(
            {
                ...form,
            },
            {
                onSuccess: () => {
                    setIsNewAccCreated(true);
                    history.push('/users');
                },
                onFailure: error => {
                    if (error && error.body) {
                        setCustomError(error?.body?.respMsg);
                    }

                    setOpen(true);
                },
            }
        );
    };

    const handleClose = () => {
        setOpen(false);
    };
    const propFromSelectedRole = item => {
        setSelectedRole(item);
    };
    return (
        <>
            <SimpleForm
                className={classes.form}
                save={onSubmit}
                toolbar={<UserCreateToolbar {...toolbarProps} />}
            >
                <TextInput
                    source="firstName"
                    type="text"
                    label="resources.registrations.fields.firstName"
                    variant="outlined"
                    fullWidth
                    validate={ValidateFirstName}
                />
                <TextInput
                    source="lastName"
                    type="text"
                    label="resources.registrations.fields.lastName"
                    variant="outlined"
                    fullWidth
                    validate={ValidateLastName}
                />
                <TextInput
                    source="email"
                    type="email"
                    label="resources.registrations.fields.email"
                    variant="outlined"
                    fullWidth
                    validate={ValidateEmail}
                />

                <RoleSelectInput onChange={propFromSelectedRole} />

                <EulaTermsInput
                    source="Terms"
                    type="checkbox"
                    validate={ValidateTerms()}
                />
            </SimpleForm>
            <CustomDialog
                title={'common.labels.error'}
                translatedContent={customError}
                content={customError}
                open={open}
                onClose={handleClose}
            />
        </>
    );
};

const ValidateTerms = () => value =>
    !value
        ? 'resources.registrations.fields.terms_of_use_validation'
        : undefined;
const ValidateEmail = [required(), email()];
const ValidateFirstName = [required(), nameValidation('FirstName')];
const ValidateLastName = [required(), nameValidation('LastName')];

const useStyles = makeStyles(
    theme => ({
        form: {
            '& >:first-child': {
                padding: 0,
            },
            '& .MuiButtonBase-root': {
                padding: '10px',
                color: 'rgba(0, 0, 0, 0.87)',
            },
        },
    }),
    {
        name: 'UserCreateForm',
    }
);
